export default "__VITE_ASSET__Ce4$tA9n__"